import { render, staticRenderFns } from "./PersonnelRecordEditTabChronicle.vue?vue&type=template&id=4d5f5282"
import script from "./PersonnelRecordEditTabChronicle.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabChronicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports